import type { UserLogoutUsecase } from '@usecases/user-logout.usecase';
import type { BaseController } from '@infra/controllers/base.controller';

export type UserLogoutInput = void;

export type UserLogoutOutput = void;

export class UserLogoutController
  implements BaseController<UserLogoutInput, UserLogoutOutput>
{
  constructor(private usecase: UserLogoutUsecase) {}

  async handle(): Promise<UserLogoutOutput> {
    await this.usecase.run();
  }
}
